module.exports = __webpack_public_path__ + "img/Development phases-Impact characterisation.45088e64.svg";